import React from 'react'
import { LoadingButton } from '@carsys/ui'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { reloadTranslations } from 'app-support/translations/state/actions'
import { useNotifier } from '@cbgms/base/notifier'

interface MapDispatchToProps {
  reloadTranslations: typeof reloadTranslations
}

type Props = MapDispatchToProps

const enhance = connect(undefined, { reloadTranslations })

export const Translations: React.FC<Props> = ({ reloadTranslations }) => {
  const { t } = useTranslation()
  const notifier = useNotifier()
  const [isLoading, setLoading] = React.useState(false)

  const onTranslationReload = async () => {
    try {
      setLoading(true)

      await reloadTranslations()

      setLoading(false)

      notifier.success(t('translations.reload_translations_success'))
    } catch {
      notifier.error(t('translations.reload_translations_failed'))
    }
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <LoadingButton data-testid='translations-reload' loading={isLoading} disabled={isLoading} onClick={onTranslationReload}>
        {t('translations.reload_translations')}
      </LoadingButton>
    </div>
  )
}

export default enhance(Translations)
